var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTopic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#007CB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 20.1989 28.921 20.3897 28.7803 20.5303C28.6397 20.671 28.4489 20.75 28.25 20.75H20.75V28.25C20.75 28.4489 20.671 28.6397 20.5303 28.7803C20.3897 28.921 20.1989 29 20 29C19.8011 29 19.6103 28.921 19.4697 28.7803C19.329 28.6397 19.25 28.4489 19.25 28.25V20.75H11.75C11.5511 20.75 11.3603 20.671 11.2197 20.5303C11.079 20.3897 11 20.1989 11 20C11 19.8011 11.079 19.6103 11.2197 19.4697C11.3603 19.329 11.5511 19.25 11.75 19.25H19.25V11.75C19.25 11.5511 19.329 11.3603 19.4697 11.2197C19.6103 11.079 19.8011 11 20 11C20.1989 11 20.3897 11.079 20.5303 11.2197C20.671 11.3603 20.75 11.5511 20.75 11.75V19.25H28.25C28.4489 19.25 28.6397 19.329 28.7803 19.4697C28.921 19.6103 29 19.8011 29 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTopic);
export default __webpack_public_path__ + "static/media/add_topic.292d466eec6004fe7c44205ff09c6180.svg";
export { ForwardRef as ReactComponent };